import * as templatesAPI from '@debbie/cortex/dist/api/templates.js';
import { getFile } from '@debbie/cortex/dist/files.js';
import { useTenantId } from '@debbie/cortex/dist/tenant/index.js';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Errors, Modal, PlaceholderLoader } from '../../components/index.js';
import { APIBASE } from '../../config.js';
import ObjectComp from '../ObjectComp.js';
export const PDFTemplatePreview = (props) => {
    const lang = useSelector((s) => s.lang);
    const tenantId = useTenantId();
    const [file, setFile] = useState(null);
    const [error, setError] = useState(null);
    useEffect(() => {
        getFile(`${APIBASE}/v1/${tenantId}` +
            templatesAPI.pdfPreviewURL(props.templateId, props.caseId, props.body, JSON.stringify(props.data), props.versionId || null))
            .then(setFile)
            .catch((err) => {
            console.error(err);
            setError(lang.interactions.downloadFailed);
        });
    }, [props.caseId, props.templateId, props.body]);
    return (React.createElement("div", null,
        file == null && error == null ? React.createElement(PlaceholderLoader, null) : null,
        error ? React.createElement(Errors, { errors: [error] }) : null,
        file ? React.createElement(ObjectComp, { url: file, type: "application/pdf" }) : null));
};
export const PDFTemplatePreviewModal = (props) => {
    const lang = useSelector((s) => s.lang);
    return (React.createElement(Modal, { onToggle: props.onToggle, header: lang.interactions.preview },
        React.createElement(PDFTemplatePreview, { ...props })));
};
//# sourceMappingURL=PDFTemplatePreview.js.map